export default __webpack_public_path__ + "static/sofiapro-light-7978d11b00722a17ccfa3208624a7ea4.otf";